<template>
  <v-card
    class="px-4"
    style="background-color: #eaeaea"
    elevation="3">
    <v-data-table
      :items="filteredBoarders"
      :headers="headers"
      dense
      :search="search"
      style="background-color: #eaeaea"
    >
      <template v-slot:top
      >
        <div class="d-flex align-center">
          <v-dialog
            v-model="dialog"
            max-width="550"
          >
            <v-spacer></v-spacer>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="black"
                outlined
                dark
                v-bind="attrs"
                v-on="on"
                @click="addBoarder()"
                v-show="canAddBoarders"
              >
                Přidat strávníka
              </v-btn>
            </template>
            <InstituionOwnerBoarderForm
              v-if="dialog && currentUser.roleId === 6"
              :boarder="editedItem"
              :available-diets="ownerInstitutionDiets"
              :user-id = user.id
              :institution="ownerInstitution"
              @data-saved="getBoarders"
            ></InstituionOwnerBoarderForm>
            <BoarderForm
              v-else-if="dialog"
              :boarder="editedItem"
              :available-diets="availableDiets"
              :user-id = user.id
              :institutions="institutions"
              @data-saved="getBoarders"
            ></BoarderForm>
          </v-dialog>

          <v-checkbox
            v-model="activeBoardersOnly"
            class="ml-4 mr-4"
            label="Pouze aktivní strávníci"
          />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledávání"
            single-line
            hide-details
            dense
            outlined
          ></v-text-field>
        </div>
      </template>
      <template v-slot:item.diet="{ item }"
      >
        <v-select
          label="Jídleníček"
          :items="filterBoarderDiets(item)"
          v-model="item.diet"
          item-text="name"
          :disabled="!canAddBoarders"
          return-object
          height="20"
          @change="changeBoarderDiet(item)"
        ></v-select>
      </template>
      <template v-slot:item.actions="{ item }"
      >
        <v-icon
          @click="editBoarder(item)">
          mdi-account-supervisor
        </v-icon>
        <v-progress-circular
          v-if="activeWait"
          indeterminate
          color="primary"
        ></v-progress-circular>
        <v-icon
          @click="toggleActive(item)"
          v-else-if="canAddBoarders"
        >
          {{item.active ? 'mdi-sleep' : 'mdi-sleep-off'}}
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import BoarderForm from './forms/admin/BoarderForm'
import InstituionOwnerBoarderForm from './forms/user/BoarderForm'
import { mapGetters } from 'vuex'
export default {
  name: 'BoardersTable',
  components: { BoarderForm, InstituionOwnerBoarderForm },
  props: ['user', 'institutionDiets', 'boarders'],
  data () {
    return {
      activeBoardersOnly: false,
      activeWait: false,
      availableDiets: [],
      dialog: false,
      institutions: [],
      editedItem: {},
      isInstitutionOwner: false,
      ownerInstitution: null,
      search: '',
      defaultItem: {
        firstName: '',
        lastName: '',
        login: '',
        loggable: false,
        institutionId: null,
        diet: null,
        userId: this.user.id
      },
      headers: [{
        text: 'Jméno',
        value: 'firstName'
      },
      {
        text: 'Příjmení',
        value: 'lastName'
      },
      {
        text: 'Přihlašování',
        value: 'loggableStr'
      },
      {
        text: 'Jídelníček',
        value: 'diet'
      },
      {
        text: '',
        value: 'actions'
      }],
      availableBoarders: []
    }
  },
  methods: {
    initialize () {
      if (this.user.roleId === 6) {
        this.$http.post('/users/institution-owner', {
          user_id: this.user.id
        })
          .then(res => {
            this.isInstitutionOwner = !!res.data.institution
            this.ownerInstitution = this.keysToCamelCase(res.data.institution)
          })
      }
      this.$http.get('/diets', {
        params: { diet_type: 'Instituční' }
      })
        .then(response => {
          this.availableDiets = this.keysToCamelCase(response.data)
            .filter(diet => diet.active)
        })
        .catch(err => { console.log(err) })
      this.$http.get('/admin/institutions')
        .then(response => {
          this.institutions = this.keysToCamelCase(response.data)
        })
        .catch(() => {})
      this.availableBoarders = this.boarders
    },
    changeBoarderDiet (boarder) {
      const options = {
        method: 'post',
        url: `/admin/users/${boarder.id}/diets`,
        data: { diets: [boarder.diet] }
      }
      this.$http(options)
        .then(response => {
          this.getBoarders()
        })
        .catch(err => console.log(err))
    },
    editBoarder (boarder) {
      this.editedItem = Object.assign({}, boarder)
      this.dialog = true
    },
    getBoarders () {
      this.dialog = false
      this.$http.get(`/admin/user/${this.user.id}/boarders`)
        .then(response => {
          this.availableBoarders = this.keysToCamelCase(response.data)
            .map(boarder => {
              boarder.loggableStr = boarder.email ? 'Ano' : 'Ne'
              boarder.diet = boarder.diets[0]
              return boarder
            })
        })
        .catch(err => console.log(err))
    },
    filterBoarderDiets (boarder) {
      return this.institutionDiets.filter(diet => diet.institutionId === boarder.institutionId)
    },
    addBoarder () {
      this.editedItem = { ...this.defaultItem }
      this.editedItem.institutionId = this.ownerInstitution.id
    },
    toggleActive (boarder) {
      this.activeWait = true
      this.$http({
        method: 'PUT',
        url: `admin/boarders/${boarder.id}/active`,
        data: {
          active: !boarder.active
        }
      }).then(res => {
        this.activeWait = false
        this.getBoarders()
      })
        .catch(err => {
          this.activeWait = false
          this.$root.$emit('api-error', err.response)
        })
    }
  },
  created () {
    this.initialize()
  },
  computed: {
    canAddBoarders () {
      return this.currentUser.roleId !== 6 || this.isInstitutionOwner
    },
    ownerInstitutionDiets () {
      if (!this.ownerInstitution) {
        return []
      }

      return this.availableDiets.filter(diet => diet.institutionId === this.ownerInstitution.id)
    },
    filteredBoarders () {
      if (this.activeBoardersOnly) {
        return this.availableBoarders.filter(boarder => boarder.active)
      } else {
        return this.availableBoarders
      }
    },
    ...mapGetters({ currentUser: 'user/currentUser' })
  }
}
</script>

<style scoped>

</style>
